import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/invest_team";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async info(params: any) {
    return api.info(params);
  }
  @Action
  async list(params: any) {
    return api.list(params);
  }
  @Action
  async list_stadium(params: any) {
    return api.list_stadium(params);
  }
  @Action
  async my_stadiums(params: any) {
    return api.my_stadiums(params);
  }
  @Action
  async setup_job(params: any) {
    return api.setup_job(params);
  }
}
